<template>
    <table class="w-100">
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.address') }}</label></td>
      <td>{{ details.address }}</td>
    </tr>
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.phone_number') }}</label></td>
      <td>{{ details.phone_number }}</td>
    </tr>
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.email_address') }}</label></td>
      <td>{{ details.email_address }}</td>
    </tr>
    </table>
</template>
<script>
export default {
  name: 'AccountAdditionalDetailsDataViewContacts',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
